import * as swcHelpers from '@swc/helpers';
import { Locales } from '@grandvisionhq/state';
import * as utils from '@grandvisionhq/utils';
import { createAltTag } from '../utils/create-alt-tag.js';
import { createProductTypeName } from '../utils/create-product-type-name.js';
import { getDiscount } from '../utils/get-discount.js';
import { getSearchLocalizedValue, getSearchJoinedLocalizedValues } from '../utils/get-search-localized-value.js';

const ENGLISH = Locales['en-GB'];
const DEFAULT_PRICE_SEGMENT = 'no-channel';
//TODO: final check when all the properties are added by the backend to the new index. Story: CXCD-9919
const mapListingProductRecordToListingProduct = (product, intl, priceSegment)=>{
    var ref;
    const { getLabel , locale  } = intl;
    const labels = {
        lens: getLabel(`products.unit.contactLens`),
        lenses: getLabel(`products.unit.contactLenses`),
        perBox: getLabel(`products.perBox`)
    };
    const slug = product.slug;
    const masterVariant = mapVariant(product, locale, labels, undefined, priceSegment);
    const productType = createProductTypeName(product.productType);
    if (!slug || !product.objectID || !productType || !masterVariant) {
        console.error('No slug, objectId, productType or masterVariant found for product sku: ', product.sku);
        return undefined;
    }
    var ref1;
    const variants = (ref1 = (ref = product.variants) === null || ref === void 0 ? void 0 : ref.map((variant)=>mapVariant(product, locale, labels, variant, priceSegment)
    ).filter(utils.isDefined)) !== null && ref1 !== void 0 ? ref1 : [];
    const firstCategory = product.categories[0];
    const category = firstCategory ? getSearchLocalizedValue(firstCategory, 'category_name', ENGLISH) : undefined;
    var ref2, ref3;
    return {
        category,
        includedVatAmount: product.includedVatAmount,
        isOnStock: product.isOnStock,
        masterVariant,
        name: {
            en: (ref2 = getSearchLocalizedValue(product, 'name', ENGLISH)) !== null && ref2 !== void 0 ? ref2 : '',
            localized: (ref3 = getSearchLocalizedValue(product, 'name', locale)) !== null && ref3 !== void 0 ? ref3 : ''
        },
        objectID: product.objectID,
        offering: undefined,
        productType,
        ratingsSummary: undefined,
        slug,
        variants,
        isOfferedWithPrescriptions: Boolean(product.isOfferedWithPrescriptions)
    };
};
const mapVariant = (product, locale, labels, variant, priceSegment)=>{
    var ref, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const altTag = createAltTag(product, locale, labels);
    const pricing = mapPricing(product, locale, variant, priceSegment);
    if (variant && !variant.brandModel && !((ref = variant.images) === null || ref === void 0 ? void 0 : ref.length) && !variant.sku) {
        console.error('Variant found with insufficiant basic info for product: ', product.sku);
        return undefined;
    }
    if (!product.brand || !product.brandModel || !product.brandModelColorCode || !((ref4 = product.images) === null || ref4 === void 0 ? void 0 : ref4.length) || // !product.erpId ||
    !product.sku) {
        console.error('product found with insufficiant basic info: ', product.sku);
        return undefined;
    }
    if (!pricing) {
        console.error('Insufficiant pricing info for product: ', product.sku);
        return undefined;
    }
    const frame = {
        color: {
            en: getSearchJoinedLocalizedValues(product, 'frameColor', ENGLISH),
            localized: getSearchJoinedLocalizedValues(product, 'frameColor', locale)
        },
        material: {
            en: getSearchLocalizedValue(product, 'frameMaterial', ENGLISH)
        },
        shape: {
            en: getSearchLocalizedValue(product, 'frameShape', ENGLISH)
        },
        type: {
            en: getSearchLocalizedValue(product, 'frameType', ENGLISH)
        }
    };
    const images = variant ? variant.images.map((img)=>swcHelpers.objectSpread({}, img, {
            altTag
        })
    ) : product.images.map((img)=>swcHelpers.objectSpread({}, img, {
            altTag
        })
    );
    const tagKey = variant ? (ref5 = variant.tags) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.key : (ref7 = product.tags) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.key;
    const tagValue = variant ? (ref9 = variant.tags) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.value : (ref11 = product.tags) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.value;
    var ref13, _name_en;
    return {
        brand: {
            name: product.brand,
            model: variant ? variant.brandModel : product.brandModel,
            modelCode: variant ? variant.brandModelCode : product.brandModelCode
        },
        erpId: 'product.erpId',
        description: (ref13 = getSearchLocalizedValue(product, 'description', locale)) !== null && ref13 !== void 0 ? ref13 : '',
        frame,
        faceShape: {
            en: getSearchJoinedLocalizedValues(product, 'faceShape', ENGLISH)
        },
        gender: {
            en: getSearchJoinedLocalizedValues(product, 'targetGender', ENGLISH)
        },
        lensColor: getSearchLocalizedValue(product, 'lensColor', locale),
        lensType: {
            en: getSearchLocalizedValue(product, 'lensType', ENGLISH)
        },
        replacementFrequency: getSearchLocalizedValue(product, 'replacementFrequency', locale),
        material: getSearchLocalizedValue(product, 'material', locale),
        accessoryType: {
            en: getSearchLocalizedValue(product, 'accessoryType', ENGLISH),
            localized: getSearchLocalizedValue(product, 'accessoryType', locale)
        },
        accessoryColor: {
            en: getSearchJoinedLocalizedValues(product, 'accessoryColor', ENGLISH),
            localized: getSearchJoinedLocalizedValues(product, 'accessoryColor', locale)
        },
        contactLensCareType: getSearchLocalizedValue(product, 'contactLensCareType', locale),
        isInsuranceReimbursable: Boolean(product.isInsuranceReimbursable),
        power: product.power,
        priceIncludedAmount: product.priceIncludedAmount,
        packageOption: product.packageOption,
        packageQuantity: product.packageQuantity,
        solutionType: product.solutionType,
        isExclusiveBrand: product.isExclusiveBrand,
        name: (_name_en = product.name_en) !== null && _name_en !== void 0 ? _name_en : '',
        sku: variant ? variant.sku : product.sku,
        tag: {
            key: tagKey,
            value: tagValue
        },
        images,
        pricing,
        consolidationFacet: null
    };
};
const mapPricing = (product, locale, variant, priceSegment)=>{
    const productPriceMap = product === null || product === void 0 ? void 0 : product.prices;
    const variantPriceMap = variant === null || variant === void 0 ? void 0 : variant.prices;
    const defaultProductPrice = productPriceMap === null || productPriceMap === void 0 ? void 0 : productPriceMap[DEFAULT_PRICE_SEGMENT];
    // new index with pricing object available on the product
    // When a product is whitelisted by the backend it will have the pricesObject available in Algolia.
    if (variantPriceMap || productPriceMap) {
        const segmentPrice = getSegmentPrice(variantPriceMap !== null && variantPriceMap !== void 0 ? variantPriceMap : productPriceMap, priceSegment);
        if (!defaultProductPrice || !segmentPrice.priceAmount || !segmentPrice.priceCurrency) return undefined;
        return {
            bestPrice: defaultProductPrice === null || defaultProductPrice === void 0 ? void 0 : defaultProductPrice.bestPrice,
            price: {
                isCentAmount: false,
                originalPrice: segmentPrice.priceAmount,
                currencyCode: segmentPrice.priceCurrency,
                discount: defaultProductPrice.discountedPrice ? {
                    description: getSearchLocalizedValue(defaultProductPrice, 'discountDescription', locale),
                    price: defaultProductPrice.discountedPrice,
                    badge: getDiscount(locale, defaultProductPrice.discountedPriceCurrencyCode, defaultProductPrice.discountType, defaultProductPrice.discountedPrice),
                    validFrom: defaultProductPrice.discountValidFrom,
                    validUntil: defaultProductPrice.discountValidUntil
                } : undefined
            },
            pricePerUnit: {
                amount: defaultProductPrice.pricePerUnitAmount,
                currencyCode: defaultProductPrice.pricePerUnitCurrency
            }
        };
    }
    // new index without pricing object available on the product
    // When a product is NOT whitelisted by the backend it wont have the pricesObject available in Algolia.
    const originalPrice = variant ? variant.priceAmount : product.priceAmount;
    const currencyCode = variant ? variant.priceCurrency : product.priceCurrency;
    if (!originalPrice || !currencyCode) return undefined;
    return {
        bestPrice: product.bestPrice,
        price: {
            isCentAmount: false,
            originalPrice,
            currencyCode,
            discount: product.discountedPrice ? {
                description: getSearchLocalizedValue(product, 'discountDescription', locale),
                price: product.discountedPrice,
                badge: getDiscount(locale, product.discountedPriceCurrencyCode, product.discountType, product.discountedPrice),
                validFrom: product.discountValidFrom,
                validUntil: product.discountValidUntil
            } : undefined
        },
        pricePerUnit: {
            amount: product.pricePerUnitAmount,
            currencyCode: product.pricePerUnitCurrency
        }
    };
};
const getSegmentPrice = (priceMap, priceSegment)=>{
    if (priceMap && priceSegment && priceSegment in priceMap) {
        const price = priceMap[priceSegment];
        return {
            priceAmount: price.priceAmount,
            priceCurrency: price.priceCurrency
        };
    } else {
        const price = priceMap === null || priceMap === void 0 ? void 0 : priceMap[DEFAULT_PRICE_SEGMENT];
        return {
            priceAmount: price === null || price === void 0 ? void 0 : price.priceAmount,
            priceCurrency: price === null || price === void 0 ? void 0 : price.priceCurrency
        };
    }
};

export { mapListingProductRecordToListingProduct, mapVariant };
//# sourceMappingURL=map-listing-product-record-to-listing-product.js.map
